import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Hashids from "hashids";
import {apiPath, serverToken} from "../../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";
import Lottie from "lottie-react";
import astronaut from "../../anim/astronaut.json";

function Settings() {

    const navigate = useNavigate();
    const hashids = new Hashids('', 10)

    const [isLoading, setIsLoading] = useState(true);
    const [serverPrices, setServerPrices] = useState(null);
    const [serverData, setServerData] = useState(null);
    const [serverStatus, setServerStatus] = useState(1)

    useEffect(() => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-server-prices', {headers})
            .then(
                res => {
                    setServerPrices(res.data.server_prices);
                    setIsLoading(false);
                }
            ).catch(err => {
                setIsLoading(false);
            }
        );

    }, []);

    useEffect(() => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-server-status', {headers})
            .then(
                res => {
                    setServerData(res.data.server);
                    setServerStatus(res.data.server.status)

                    setIsLoading(false);
                }
            ).catch(err => {
                console.log(err)
                setIsLoading(false);
            }
        );
    }, [])

    if (!serverPrices || !serverData) {
        return (
            <div className="container mx-auto flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    if (serverPrices.length === 0) {
        return (
            <div className="container mx-auto h-screen flex flex-col justify-center items-center">
                <Lottie className="w-full lg:w-1/3" animationData={astronaut} loop={true}/>
                <p className="py-5">No hay nada para mostrar</p>
            </div>
        );
    }

    const handleServerStatusMessage = () => {

        if (!!serverStatus) {
            return "Servidor activo"
        } else {
            return serverData.offline_message
        }

    }

    const handleServerStatus = (event) => {

        event = !serverStatus ? 1 : 0

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/change-server-status/' + event, {headers})
            .then(
                res => {

                    let responseSuccess = res.data.success

                    if (responseSuccess)
                        setServerStatus(event)

                }
            ).catch(err => {
            }
        );

    }

    const handleEditPrice = (id) => {
        let hashedID = hashids.encode(id)
        navigate("/actualizar-precio/" + hashedID)
    }

    return (
        <div>

            <div className="w-full p-5 mb-5 bg-white rounded-lg">

                <div className="flexitems-center">

                    <div className="flex flex-col">
                        <div className="flex flex-row justify-between">

                            <p className="text-sm lg:text-lg"> Estado del servidor</p>

                            <div>
                                <label htmlFor="small-toggle"
                                       className="inline-flex relative items-center cursor-pointer">
                                    <input type="checkbox" checked={!!serverStatus} value=""
                                           onChange={(event) => handleServerStatus(event.target)} id="small-toggle"
                                           className="sr-only peer"/>
                                    <div
                                        className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-sky-900 dark:peer-focus:ring-sky-900 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-sky-500"></div>
                                </label>
                            </div>
                        </div>

                        <p className="text-xs md:text-sm text-gray-500">{handleServerStatusMessage()}</p>
                    </div>

                </div>
            </div>

            <div className="px-4 pb-5 overflow-y-auto bg-white rounded-lg">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="h-16 w-full text-sm leading-none text-gray-800">
                        <th className="font-normal text-left text-start">Titulo</th>
                        <th className="font-normal text-left text-start">Precio Día</th>
                        <th className="font-normal text-left text-start">Precio Noche</th>
                        <th className="font-normal text-left text-center">Acciones</th>
                    </tr>
                    </thead>
                    <tbody className="w-full">
                    {serverPrices.map((serverPrice) => {
                        return (
                            <tr key={serverPrice.id}
                                className="h-20 text-sm leading-none text-gray-800 bg-white hover:bg-gray-50 border-b border-t border-gray-100">

                                <td className="px-4 mt-4">
                                    <div className="flex items-center">
                                        <p className="font-medium">{serverPrice.title}</p>
                                    </div>

                                    <p className="text-sm leading-3 text-gray-600 pt-2">{serverPrice.description}</p>
                                </td>

                                <td className="text-start">
                                    <p className="text-sm leading-none text-gray-700">{serverPrice.price_day} CUP</p>
                                </td>

                                <td className="text-start">
                                    <p className="text-sm leading-none text-gray-700">{serverPrice.price_night} CUP</p>
                                </td>

                                <td className="text-center">
                                    <button onClick={() => handleEditPrice(serverPrice.id)}
                                            className="text-sm text-gray-600 hover:text-sky-400 mx-2">
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>


            </div>

        </div>
    );
}

export default Settings;